import { UserPostsState } from "src/state/tree/userPosts";

export default {
  getIsUserPostsListVisible: (state: UserPostsState) =>
    state.isUserPostsListVisible,
  getUserPostsInfo: (state: UserPostsState) => state,
};
